export default __webpack_public_path__ + "static/media/vero-marketplace-logo.dbf250ff.svg";